import { useMutation } from '@tanstack/react-query';
import { type CreateComparisonRequest } from '../../../types/BaselineMeasurements';
import { baselineMeasurementService } from '../../../Domain/BaselineMeasurements/Services';

type CreateComparisonResponse = {};

const mutationFn = async (data: CreateComparisonRequest) => {
  const response = await baselineMeasurementService.createComparisonFromEvents(data);
  return response.data;
};

export const useCreateComparisonFromEventsMutation = () => {
  return useMutation<CreateComparisonResponse, unknown, CreateComparisonRequest>(mutationFn);
};
